import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  load=false
  appointments
  doctorInfo
  roomInfo
  billingReports
  questionnaire

  constructor(private http: HttpClient) { }

  // AR-24: load a patient's answered-questionnaire snapshot for the PDF print
  // page (print/questionnaire/:code). Hits the PUBLIC (no-auth) endpoint so
  // headless Chrome can load it with no session cookie.
  loadQuestionnaireAnswers(code) {
    if (!code) return;
    console.log('AR-24 print-questionnaire: fetching /api/questionnaires/answers/' + code);
    this.http.get('/api/questionnaires/answers/' + code).subscribe({
      next: (data) => {
        console.log('AR-24 print-questionnaire: loaded, status=' + (data && data['status']));
        this.questionnaire = data;
        this.load = true;
      },
      error: (err) => {
        console.error('AR-24 print-questionnaire: failed to load answers for code ' + code + ' - status ' + err.status + ' ' + JSON.stringify(err.error));
      },
    });
  }


  loadAppointments(type, startDate, endDate, ID, code, isRoom = false, isMulti = false) {
    if (!type || !startDate) return;
  
    let params: any = { start: startDate, end: endDate };
  
    if (code) params.code = code;
  
    if (isMulti) {
      if (isRoom) {
        params.RIDs = ID;
      } else {
        params.UIDs = ID;
      }
    } else {
      if (isRoom) {
        params.RID = ID;
      } else {
        params.UID = ID;
      }
    }

    this.http.get('/api/appointment/appointmentsForPrint', { params }).subscribe((data) => {
      this.appointments = data['appointments'];
      this.doctorInfo = data['doctorInfo'];
      this.roomInfo = data['roomInfo'];
      this.load = true;
    });
  }  

  loadBillingReport(docType, fromDate, toDate, UID, code) {
    if (!docType || !fromDate) return;

    let params = {
      UID: UID,
      docType: docType,
      toDate: toDate,
      fromDate: fromDate,
    };

    if (code) {
      params["code"] = code;
    }

    this.http.get("/api/billing/reportsForPrint", { params: params }).subscribe((data) => {
      this.billingReports = data['billingReports'];
      this.doctorInfo=data['doctorInfo']
      this.load = true;
    });
  }
}
